import React from 'react';
import omitDeep from 'omit-deep-lodash';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { createNetworkStatusNotifier } from 'react-apollo-network-status';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { split } from 'apollo-link';
import { WebSocketLink } from 'apollo-link-ws';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { getMainDefinition } from 'apollo-utilities';
import { get } from 'lodash';
import packageJson from '../../package.json';
import { firebaseApp } from 'shared/firebase';
import { environments } from 'shared/utils/environments';
// NOTE: due to how dotenv works in webpack we need to do this
const uri = `${environments.apiUrl}/graphql`;
const ws = process.env.WS_URL;

function updateToken() {
  const user = firebaseApp.auth().currentUser;
  if (user) {
    user.getIdToken(true).then(function(idToken) {
      localStorage.setItem('cofe-district:id_token', `${idToken}`);
    });
  }
}

const { link: networkStatusNotifierLink } = createNetworkStatusNotifier();
const cleanTypenameLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = omitDeep(operation.variables, '__typename');
  }

  return forward(operation).map(data => data);
});

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
    console.log(graphQLErrors);
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
      if (message === 'Insufficient privileges !') {
        return updateToken();
      }
    });
  }

  if (networkError) {
    console.warn(`[Network error]: ${networkError}`);

    // NOTE: we want to redirect users to login if we get a 401 from server
    if (networkError.statusCode === 401) {
      firebaseApp
        .auth()
        .signOut()
        .then(() => forward(operation));
    }
  }
});

const httpLink = createHttpLink({
  uri,
});

const authLink = setContext(() => ({
  headers: {
    'API-TOKEN': process.env.API_TOKEN,
    authorization: `Bearer ${localStorage.getItem('cofe-district:id_token')}`,
  },
}));

const wsClient = new SubscriptionClient(ws, {
  reconnect: true,
  inactivityTimeout: 0,
  connectionParams: () => ({ authorization: `Bearer ${localStorage.getItem('cofe-district:id_token')}` }),
  connectionCallback: err => {
    if (get(err, 'message') === 'Authentication Failure!') {
      return updateToken();
    }
  },
});

const wsLink = new WebSocketLink(wsClient);

// WebSocket Link
// const wsLink = new WebSocketLink(wsClient);
// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
  // split based on operation type
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === 'OperationDefinition' && operation === 'subscription';
  },
  wsLink,
  ApolloLink.from([cleanTypenameLink, authLink, errorLink, networkStatusNotifierLink, httpLink])
);
const client = new ApolloClient({
  link,
  cache: new InMemoryCache(),
  name: 'admin-portal',
  version: packageJson?.version,
});
export { wsClient };
export default client;
